/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoGenerateTestSubmissionEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AUTO_GENERATE_TEST_SUBMISSION_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class AutoGenerateTestSubmissionEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoGenerateTestSubmissionEnabledSettingParser.decode(input).map(res => new AutoGenerateTestSubmissionEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return AutoGenerateTestSubmissionEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoGenerateTestSubmissionEnabledSettingParser.encode(data);
    }
    static schema() {
        return AutoGenerateTestSubmissionEnabledSettingParser.schema();
    }
}
